import { render, staticRenderFns } from "./MyResume.vue?vue&type=template&id=9b17bab2&scoped=true&"
import script from "./MyResume.vue?vue&type=script&lang=ts&"
export * from "./MyResume.vue?vue&type=script&lang=ts&"
import style0 from "./MyResume.vue?vue&type=style&index=0&id=9b17bab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b17bab2",
  null
  
)

export default component.exports